import MyAxios from 'axios';
import { getToken } from './get-token';

const axios = MyAxios.create({
  baseURL: process.env.NODE_ENV === "production" ? "https://oppdb.piano-piano.org/api" : "http://localhost:8000/api",
  timeout: 300000000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token ? token : ''}`,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// export class HttpClient {
//   static async get(url, params) {
//     console.log("url", url)
//     const response = await axios.get(url, { params });
//     return response;
//   }

//   static async post(url, data, options) {
//     const response = await axios.post(url, data, options);
//     return response;
//   }
// }


export default axios;
